import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { Box } from "@mui/material";

const baseStyles = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.5rem 1.5rem",
  borderRadius: "2rem",
  width: "fit-content",
  border: "0.125rem solid",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.3s ease",
};

const selectedStyles = {
  ...baseStyles,
  borderColor: "border.main",
  backgroundColor: "#F5F3FF",
  color: "text.main",
  "&:hover": {
    backgroundColor: "#EDE9FE",
  },
};

const unselectedStyles = {
  ...baseStyles,
  borderColor: "border.disabled",
  backgroundColor: "transparent",
  color: "text.disabled",
  "&:hover": {
    backgroundColor: "#F9FAFB",
  },
};

const CustomCheckbox = ({ selected, label, onClick }) => {
  return (
    <Box onClick={onClick} sx={{
      ...(selected ? selectedStyles : unselectedStyles),
      padding: "0.45rem 0.85rem"
    }}>
      {selected ? (
        <CheckCircleIcon sx={{ color: "primary.main" }} />
      ) : (
        <RadioButtonUnchecked />
      )}
      {label}
    </Box>
  );
};

export default CustomCheckbox;
